import styled from 'styled-components';

export const Wrapper = styled.div<{ zeroPadding: boolean; marginBottom?: string }>`
  z-index: 1;
  position: relative;
  padding: ${({ zeroPadding }) => (zeroPadding ? '0' : '0 32px')};
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};

  button {
    margin-left: 8px;
  }

  div {
    margin-right: auto;
  }

  &:before {
    top: 0;
    content: '';
    display: block;
    background-color: var(--colorBlueGray1000);
    height: 100%;
    width: 100vw;
    position: absolute;
    left: -32px;
    pointer-events: none;
    z-index: -1;
  }
`;

export const InnerWrapper = styled.div<{ hasIcon: boolean; minHeight: string }>`
  z-index: 1;
  position: relative;
  padding: ${({ hasIcon }) => (hasIcon ? '16px 0 14px 24px' : '16px 0 14px')};
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  min-height: ${({ minHeight }) => minHeight};

  p {
    max-width: 400px;
  }
`;

export const IconWrapper = styled.div<{ isOpen: boolean }>`
  height: 30px;
  width: 30px;
  position: absolute;
  left: -6px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    transition: transform 0.2s ease-in-out, fill 0.2s ease-in-out;
    transform-origin: center;
    fill: var(--colorBlueGray800);
    width: 20px;
    height: 20px;
  }

  &:hover {
    svg {
      fill: var(--colorWhite);
    }
  }
`;
